export default __webpack_public_path__ + "ui/assets/img/search-20.svg";